(function (w, $, _) {
    'use strict';

    const assetId = '~/Parts/Views/Product/ProductFilters/ProductFiltersThemeV1.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (var ctx of w.umwAssets[assetId]) {

        var controlId = ctx.controlId;
        var productListControlId = ctx.productListControlId;
        var productListPageControlID = ctx.productListPageControlID;
        var filtersTemplateContent = ctx.filtersTemplateContent;
        var labels = ctx.labels;
        var currencyCode = ctx.currencyCode;
        var enableImmediateFiltering = ctx.enableImmediateFiltering;
        var rememberChoiceFor = ctx.rememberChoiceFor;
        var slideFilteringFor = ctx.slideFilteringFor;
        var enableFiltersURLSupport = ctx.enableFiltersURLSupport;
        var showInStockFilter = ctx.showInStockFilter;
        var showOnlyInStock = ctx.showOnlyInStock;
        var hasSortOptions = ctx.hasSortOptions;
        var sortingOptions = ctx.sortingOptions;
        var initSortingOption = ctx.initSortingOption;

        var handlerUrl = w.R + 'Handlers/Public/ProductData.ashx';

        var pubSub = w.PubSub;
        var filtersChannelPrefix = 'frontend.productlist.filters.' + (productListPageControlID || productListControlId);
        var staticfilterChannelPrefix = 'frontend.productlist.staticfilter.' + (productListPageControlID || productListControlId);
        var listReadyChannelPrefix = 'frontend.productlist.ready.' + (productListPageControlID || productListControlId);
        var precompiledTemplate;

        var $filters, excludedItemsMap = {}, allItems, appliedFilters = {};
        var $mainPanel, $filtersContainer, $buttonsContainer, $resetButton, $closeButton, $cbxShowOnlyInStock, $sortSelector;

        var savedFiltersLocalStorageKey = controlId + '_saved_filters';

        var classes = {
            productFilters: 'js-uc' + controlId + '-product-filters',
            noFiltersAvailable: 'NoFiltersAvailable',
            template: 'js-uc' + controlId + '-template',
            filtersContainer: 'js-uc' + controlId + '-filters-container',
            buttonsContainer: 'js-uc' + controlId + '-buttons-container',
            filter: 'js-uc' + controlId + '-filter',
            checkboxFilter: 'js-uc' + controlId + '-checkbox-filter',
            sliderFilter: 'js-uc' + controlId + '-slider-filter',
            sliderContainer: 'js-uc' + controlId + '-slider-container',
            minValue: 'js-uc' + controlId + '-min-value',
            maxValue: 'js-uc' + controlId + '-max-value',
            itemsCount: 'js-uc' + controlId + '-items-count',
            resetBtn: 'js-uc' + controlId + '-reset-btn',
            closeBtn: 'js-uc' + controlId + '-close-btn',
            dropdownItem: 'js-uc' + controlId + '-dropdown-item',
            showOnlyInStock: 'js-uc' + controlId + '-show-only-in-stock',
            sortSelector: 'js-uc' + controlId + '-sort-selector',
            totalCount: 'js-uc' + controlId + '-total-count',
            totalCountContainer: 'js-uc' + controlId + '-total-count-container',
        };

        var domReady = false;
        var filtersData = null;
        var preAppliedFilterState = null;

        function onResetButtonClick(evt) {
            evt.preventDefault();

            w.removeFromLocalStorage(savedFiltersLocalStorageKey);

            resetAllFilters();
            applyFilters();
        }

        function loadFilters(applyFiltersCallback) {
            var query = $.extend($.getUrlParamsObj(location.search), {
                action: 'GetFilters',
                controlId: controlId,
                pageId: w.BasePageID,
                showOnlyInStock: showOnlyInStock
            });

            if (domReady) {
                blockUI();
            }

            $.get(handlerUrl, query)
                .done(function (responseData) {
                    if (domReady) {
                        showFilters(responseData, applyFiltersCallback);
                    } else {
                        filtersData = responseData;
                    }
                })
                .fail(function (errResp) {
                    var message;
                    if (typeof (errResp) === 'object') {
                        // Extract error message
                        var responseObj = JSON.parse(errResp.responseText);
                        message = responseObj.Message ? responseObj.Message : errResp.statusText;
                    } else {
                        message = errResp;
                    }
                    notify(labels.failedToLoadFilters + '<br />' + message, 'error');
                })
                .always(function () {
                    if (domReady) {
                        unblockUI();
                    }
                });
        }

        function showFilters(data, applyFiltersCallback) {
            var filters = data.filters;
            allItems = data.allItemIDs;

            if ((!filters || !filters.length) && !$cbxShowOnlyInStock.length) {
                $mainPanel.hide();
                pubSub.publish(filtersChannelPrefix + '.empty');
            } else {
                if (typeof (precompiledTemplate) === 'undefined') {
                    precompiledTemplate = _.template(filtersTemplateContent);
                }

                if (w.siteScripts) {
                    filters = w.siteScripts.converters.apply('ProductFilters', filters);
                }

                _.each(filters, function (filter, filterIdx) {
                    filter.clientId = ['filter', filter.FilterType, filterIdx].join('_');
                    filter.slideble = slideFilteringFor.indexOf(filter.Name) > -1;
                    _.each(filter.Criterias, function (criteria, criteriaIdx) {
                        criteria.clientId = [filter.clientId, 'criteria', criteriaIdx].join('_');
                        if (filter.slideble) {
                            filter.slideble = extractNumberFromString(criteria.Name) !== null;
                        }
                    });
                });

                var filtersHtml = precompiledTemplate({
                    controlId: controlId,
                    filters: filters,
                    labels: labels,
                    currencyCode: currencyCode,
                    enableImmediateFiltering: enableImmediateFiltering,
                    showInStockFilter: showInStockFilter,
                    hasSortOptions: hasSortOptions,
                    sortingOptions: sortingOptions,
                    initSortingOption: initSortingOption,
                });

                $filtersContainer.html(filtersHtml);
                runTemplateLocalScript(filters);

                if (filters.length) {
                    $filters = $mainPanel.find('.' + classes.filter);
                    initFilters(filters);

                    if (typeof applyFiltersCallback === 'function') {
                        applyFiltersCallback();
                    } else {
                        // Restore filters state from the url or local storage
                        // Url values should always override the local storage ones
                        try {
                            var preAppliedFilters;

                            var filterHash = location.href.split('#')[1] || '{}'; // Why not just location.hash? See http://stackoverflow.com/a/1704842/1855879

                            var filtersFromUrl = enableFiltersURLSupport
                                ? filterHash.startsWith('{')
                                    ? JSON.parse(decodeURIComponent(filterHash))
                                    : getFiltersFromFriendlyUrl(filterHash)
                                : {};

                            if (!_.isEmpty(filtersFromUrl)) {
                                preAppliedFilters = filtersFromUrl;
                            } else {
                                // Grab saved filters from the local storage
                                var savedFiltersFromLocalStorageJSON = w.getFromLocalStorage(savedFiltersLocalStorageKey);
                                preAppliedFilters = typeof (savedFiltersFromLocalStorageJSON) !== 'undefined' ? JSON.parse(savedFiltersFromLocalStorageJSON) : null;
                            }

                            if (!_.isEmpty(preAppliedFilters)) {
                                setAppliedFilters(preAppliedFilters); // restore filters state
                                applyFilters(true); // reload product list
                            }
                        } catch (e) {
                            console.error('%s - Failed to restore filters: %s', controlId, e.message || e);
                        }
                    }

                    $filtersContainer.removeClass(classes.noFiltersAvailable);
                    $buttonsContainer.css({'display': 'flex'});
                    pubSub.publish(filtersChannelPrefix + '.load', filters);
                } else {
                    $filtersContainer.addClass(classes.noFiltersAvailable);
                    $buttonsContainer.hide();
                }
            }

            updateCounterSelectedCriteria();
            updateTotalProductCount();

            function getFiltersFromFriendlyUrl(filterHash) {
                filterHash = decodeURIComponent(filterHash);
                var filterParts = filterHash.split('/').splice(1);
                var foundFilter = null;
                var prevFoundFilter = null;
                var filtersFromUrl = {};

                _.each(filterParts, function (filterOrCriteriaName) {
                    if (foundFilter) {
                        findAndAddCriteria(foundFilter, filterOrCriteriaName);
                        prevFoundFilter = foundFilter;
                        foundFilter = null;
                    } else {
                        foundFilter = findByName(filters, filterOrCriteriaName);
                        //if no filter found, then current name may belong to one of criterias from previously found filter
                        if (!foundFilter) {
                            if (prevFoundFilter) {
                                findAndAddCriteria(prevFoundFilter, filterOrCriteriaName);
                            } else {
                                throw 'No filter found by name: ' + filterOrCriteriaName;
                            }
                        }
                    }
                });

                return filtersFromUrl;

                function findAndAddCriteria(foundFilter, urlItem) {
                    var filterValue;
                    if (foundFilter.slideble)
                        filterValue = parseFloat(urlItem.replace(/-/g, '.'));
                    else {
                        var foundCriteria = findByName(foundFilter.Criterias, urlItem);
                        if (!foundCriteria) {
                            throw 'No criteria found by name: ' + urlItem;
                        }
                        filterValue = foundCriteria.Name;
                    }

                    if (filtersFromUrl[foundFilter.Name]) {
                        filtersFromUrl[foundFilter.Name].push(filterValue);
                    } else {
                        filtersFromUrl[foundFilter.Name] = [filterValue];
                    }
                }

                function findByName(filtersOrCriterias, name) {
                    return _.find(filtersOrCriterias, function (item) {
                        var preparedName = item.Name.toLowerCase();
                        //replace invalid chars with dash
                        preparedName = preparedName.replace(/[^a-z0-9æøå-]/g, '-');
                        //replace sequences of dashes with a single dash
                        preparedName = preparedName.replace(/-+/g, '-');
                        return preparedName === name;
                    });
                }
            }

            function initFilters(filtersData) {
                $filters.each(function () {
                    var $filter = $(this);
                    var filterData = _.find(filtersData, function (filter) { return filter.clientId == $filter.attr('id'); });
                    $filter.data('item', filterData);

                    if ($filter.hasClass(classes.checkboxFilter)) {
                        filterData.slideble = false;
                        $filter.change(onCheckboxFilterChange);

                    } else if ($filter.hasClass(classes.sliderFilter)) {
                        filterData.slideble = true;
                        var numericCriterias = getNumericCriterias(filterData.Criterias);
                        var minValue = _.min(numericCriterias);
                        var maxValue = _.max(numericCriterias);
                        var sliderValues = [minValue, maxValue];
                        var templateName = $('.' + classes.template).val();
                        var $mobileCloseBtn = $('.' + classes.closeBtn);
                        // Init slider
                        $filter.find('.' + classes.sliderContainer).slider({
                            range: true,
                            min: minValue,
                            max: maxValue,
                            step: isFloat(minValue) || isFloat(maxValue) ? 0.01 : 1,
                            values: sliderValues,
                            slide: onSliderFilterChange,
                            change: function (event) {
                                // Do not process change events fired by programmatic changes
                                if ((enableImmediateFiltering || templateName === 'horizontal-theme-v1') && typeof (event.originalEvent) !== 'undefined') {
                                    switch (templateName) {
                                        case 'horizontal-theme-v1':
                                            if($mobileCloseBtn.is(":hidden")){
                                                applyFilters();
                                            }
                                          break;
                                        default:
                                            applyFilters();
                                    }
                                }
                            }
                        });

                        // Set initial values
                        updateSliderInfo($filter, sliderValues);
                    }
                });

                function onCheckboxFilterChange() {
                    // Get all filtered by the current filter items and store them into the map, independently from the other filters.
                    // Later, all the items from the filtered items map will be joined to the resulted set
                    var $filter = $(this);
                    var filterData = $filter.data('item');
                    var templateName = $('.' + classes.template).val();

                    var $selectedCriterias = $filter.find('input:checkbox:checked');
                    if ($selectedCriterias.length > 0) {
                        // Filter is applied
                        var selectedCriteriaIds = $selectedCriterias.map(function () { return this.id; }).get();
                        var selectedCriterias = getSelectedCheckboxCriterias(filterData.Criterias, selectedCriteriaIds);
                        excludedItemsMap[filterData.clientId] = _.difference(allItems, getCriteriasItems(selectedCriterias));
                        appliedFilters[filterData.Name] = _.pluck(selectedCriterias, 'Name');
                    } else {
                        // Filter is not applied
                        delete excludedItemsMap[filterData.clientId];
                        delete appliedFilters[filterData.Name];
                    }

                    updateOtherFilters($filter);

                    // Ignore enableImmediateFiltering for horizontal-theme-v1 template and applyFilters on every checkbox change
                    if (enableImmediateFiltering || templateName === 'horizontal-theme-v1') {
                        applyFilters();
                    }
                }

                function onSliderFilterChange(event, ui) {
                    var $slider = $(ui.handle);
                    var $filter = $slider.closest('.' + classes.sliderFilter);
                    var filterData = $filter.data('item');

                    var selectedCriterias = getSelectedSliderCriterias(filterData.Criterias, ui.values[0], ui.values[1]);
                    var selectedCriteriasItems = getCriteriasItems(selectedCriterias);

                    excludedItemsMap[filterData.clientId] = _.difference(allItems, selectedCriteriasItems);
                    appliedFilters[filterData.Name] = ui.values;

                    updateSliderInfo($filter, ui.values);

                    updateOtherFilters($filter);
                }
            }
        }

        function updateOtherFilters($appliedFilter) {
            // When some filter criterias are applied, the criterias of the other filters should be updated with the new total items values according to the newly applied criterias.
            $filters.not($appliedFilter).each(function () {
                var $filter = $(this);
                var filterData = $filter.data('item');
                var availableItems = [];
                var allItemsExcludedByOtherFilters = getAllItemsExcludedByOtherFilters(filterData.clientId);

                if ($filter.hasClass(classes.checkboxFilter)) {
                    _.each(filterData.Criterias, function (criteria) {
                        var $criteriaCheckbox = $filter.find('#' + criteria.clientId);
                        var $criteriaCheckboxCounter = $filter.find('label[for="' + criteria.clientId + '"] .' + classes.itemsCount);
                        availableItems = _.difference(criteria.Items, allItemsExcludedByOtherFilters);
                        $criteriaCheckboxCounter.text(availableItems.length);
                        $criteriaCheckbox.prop('disabled', availableItems.length === 0);
                    });

                } else if ($filter.hasClass(classes.sliderFilter)) {
                    var $currentSlider = $filter.find('.' + classes.sliderContainer);
                    var onlyIncludedItems = _.difference(allItems, getAllExcludedItems());
                    var numericCriterias = getNumericCriterias(filterData.Criterias, onlyIncludedItems);

                    if (numericCriterias && numericCriterias.length) {
                        var sliderValues = [
                            _.min(numericCriterias),
                            _.max(numericCriterias)
                        ];
                        $currentSlider.slider('values', sliderValues);
                        updateSliderInfo($filter, sliderValues);
                    }
                }
            });
            pubSub.publish(filtersChannelPrefix + '.update');
        };

        function getNumericCriterias(allCriterias, onlyIncludedItems) {
            var result = [];
            _.each(allCriterias, function (criteria) {
                if (criteria.Items !== undefined &&
                    onlyIncludedItems !== undefined &&
                    !_.intersection(criteria.Items, onlyIncludedItems).length) {
                    return;
                }
                var number = extractNumberFromString(criteria.Name);
                result = _.union(result, [parseFloat(number)]);
            });
            return result;
        }

        //#region Helpers

        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        };

        function extractNumberFromString(inpurString) {
            var regex = /[+-]?\d+(?:\.\d+)?/g;
            var isMatch = inpurString.match(regex);

            return isMatch ? isMatch[0] : null;
        }

        function updateSliderInfo($filter, sliderValues) {

            var $minValueContainer = $filter.find('.' + classes.minValue);
            var $maxValueContainer = $filter.find('.' + classes.maxValue);
            var $itemsCountContainer = $filter.find('.' + classes.itemsCount);

            var minValue = _.min(sliderValues);
            $minValueContainer.text(minValue);
            var maxValue = _.max(sliderValues);
            $maxValueContainer.text(maxValue);

            var newTotal = _.difference(allItems, getAllExcludedItems()).length;
            $itemsCountContainer.text(newTotal);
            pubSub.publish(filtersChannelPrefix + '.update');
        }

        function getCriteriasItems(criterias) {
            // optimized function only for simple types. UMWC-2830
            function itemsUnion(x, y) {
                var result = [];
                for (var xi = 0; xi < x.length; ++xi) {
                    result.push(x[xi]);
                }
                for (var yi = 0; yi < y.length; ++yi) {
                    var item = y[yi];
                    var exists = false;
                    for (var j = 0; j < result.length; ++j)
                        if (result[j] === item) {
                            exists = true;
                            break;
                        }
                    if (!exists)
                        result.push(item);
                }
                return result;
            }
            return _.reduce(criterias, function (memo, criteria) {
                return itemsUnion(memo, criteria.Items);
            }, []);
        }

        function getSelectedCheckboxCriterias(allCriterias, selectedCriteriaIds) {
            return _.filter(allCriterias, function (criteria) {
                return _.contains(selectedCriteriaIds, criteria.clientId) && _.some(criteria.Items);
            });
        }

        function getSelectedSliderCriterias(allCriterias, selectedMin, selectedMax) {
            return _.filter(allCriterias,
                function (criteria) {
                    var number = extractNumberFromString(criteria.Name);
                    var numericCriteria = parseFloat(number);
                    return (numericCriteria >= selectedMin && numericCriteria <= selectedMax) && _.some(criteria.Items);
                });
        }

        function getAllExcludedItems() {
            return _.reduce(excludedItemsMap, function (allExcludedItems, excludedMapItem) {
                return _.union(allExcludedItems, excludedMapItem);
            }, []);
        }

        function getAllItemsExcludedByOtherFilters(currentFilterName) {
            return _.reduce(excludedItemsMap,
                function (allExcludedItems, excludedMapItem, excludedByFilterName) {
                    return currentFilterName !== excludedByFilterName
                        ? _.union(allExcludedItems, excludedMapItem)
                        : allExcludedItems;
                },
                []);
        }

        function setAppliedFilters(filtersToApply) {
            // Reset current filters first
            excludedItemsMap = {};
            appliedFilters = filtersToApply || {};

            $filters.each(function () {
                var $filter = $(this);
                var filterData = $filter.data('item');
                var filterId = filterData.clientId;
                var filteredValues = appliedFilters[filterData.Name];
                var selectedCriterias = [];

                if ($filter.hasClass(classes.checkboxFilter)) {
                    // Clear previous values
                    $filter.find('input:checkbox').prop('checked', false);

                    if (filteredValues && filteredValues.length) {
                        _.each(filterData.Criterias, function (criteria) {
                            if (_.contains(filteredValues, criteria.Name)) {
                                $filter.find('#' + criteria.clientId).prop('checked', true);
                                selectedCriterias.push(criteria);
                                excludedItemsMap[filterId] = _.difference(allItems, getCriteriasItems(selectedCriterias));
                            }
                        });
                    }
                } else if ($filter.hasClass(classes.sliderFilter)) {
                    var sliderValues = filteredValues;
                    var $currentSlider = $filter.find('.' + classes.sliderContainer);
                    if (sliderValues && sliderValues.length == 2 && sliderValues[0] <= sliderValues[1]) {
                        selectedCriterias = getSelectedSliderCriterias(filterData.Criterias, sliderValues[0], sliderValues[1]);
                        excludedItemsMap[filterId] = _.difference(allItems, getCriteriasItems(selectedCriterias));
                    } else {
                        // Reset slider
                        var minRangeValue = $currentSlider.slider('option', 'min');
                        var maxRangeValue = $currentSlider.slider('option', 'max');
                        sliderValues = [minRangeValue, maxRangeValue];
                    }

                    $currentSlider.slider('values', sliderValues);
                    updateSliderInfo($filter, sliderValues);
                }

                updateOtherFilters($filter);
            });
        };

        function resetAllFilters() {
            excludedItemsMap = {};
            appliedFilters = {};

            $filters.each(function () {
                var $filter = $(this);
                var filterData = $filter.data('item');

                if ($filter.hasClass(classes.checkboxFilter)) {
                    _.each(filterData.Criterias, function (criteria) {
                        var $criteriaCheckbox = $filter.find('#' + criteria.clientId);
                        $criteriaCheckbox.prop('checked', false);
                        $criteriaCheckbox.prop('disabled', false);
                        var $criteriaCheckboxCounter = $filter.find('label[for="' + criteria.clientId + '"] .' + classes.itemsCount);
                        $criteriaCheckboxCounter.text(criteria.Items.length);
                    });
                } else if ($filter.hasClass(classes.sliderFilter)) {
                    var $filterSlider = $filter.find('.' + classes.sliderContainer);
                    var numericCriterias = getNumericCriterias(filterData.Criterias);
                    var minValue = _.min(numericCriterias);
                    var maxValue = _.max(numericCriterias);

                    var sliderValues = [minValue, maxValue];
                    $filterSlider.slider('values', sliderValues);

                    updateSliderInfo($filter, sliderValues);
                }
            });
        };

        function setFiltersToFriendlyUrl(appliedFilters) {
            //join all filters and their criterias in a single string, separated by slash
            //replace slash in filter and criteria names, because slash is used as a separator when restoring filters from URL
            var filterUrl = _.reduce(appliedFilters,
                function (memo, criterias, filterName) {
                    return memo + '/' + filterName.replace(/\//g, '-') +
                        _.reduce(criterias, function (memo2, criteriaName) { return memo2 + '/' + (criteriaName.replace ? criteriaName.replace(/\//g, '-') : criteriaName); }, '');
                }, '');
            filterUrl = filterUrl.toLowerCase();
            //replace invalid chars with dash
            filterUrl = filterUrl.replace(/[^a-z0-9æøå\/-]/g, '-');
            //replace sequences of dashes with a single dash
            filterUrl = filterUrl.replace(/-+/g, '-');

            return filterUrl;
        }

        function applyFilters(isRestoring, isHistoryPopEvent) {
            var excludedItems = getAllExcludedItems();
            var allIncludedItems = excludedItems.length > 0 ? _.difference(allItems, excludedItems) : null;

            var filtersUrl = '';
            if (enableFiltersURLSupport) {
                filtersUrl = setFiltersToFriendlyUrl(appliedFilters);
            }

            var filterState = {
                filteredItemIds: allIncludedItems,
                allItemsCount: allItems.length,
                appliedFilters: appliedFilters,
                filtersUrl: filtersUrl,
                isRestoring: isRestoring === true,
                isHistoryPopEvent: isHistoryPopEvent === true,
                showOnlyInStock: showOnlyInStock
            };

            if (isRestoring && !preAppliedFilterState) {
                filterState.isPreApplied = true;
                preAppliedFilterState = filterState;
            }

            pubSub.publish(filtersChannelPrefix + '.apply', filterState);

            if (rememberChoiceFor.length > 0) {
                var appliedFiltersToRemember = {};
                if (!_.isEmpty(appliedFilters)) {
                    appliedFiltersToRemember = _.pick(appliedFilters, rememberChoiceFor);
                }

                w.saveToLocalStorage(savedFiltersLocalStorageKey, JSON.stringify(appliedFiltersToRemember));
            } else if (w.getFromLocalStorage(savedFiltersLocalStorageKey)) {
                w.removeFromLocalStorage(savedFiltersLocalStorageKey);
            }

            updateTotalProductCount();
        }
        function applySelectedCheckboxesFilter(filter) {
            // Get all filtered by the current filter items and store them into the map, independently from the other filters.
            // Later, all the items from the filtered items map will be joined to the resulted set
            var $filter = filter;
            var filterData = $filter.data('item');

            var $selectedCriterias = $filter.find('input:checkbox:checked');
            if ($selectedCriterias.length > 0) {
                // Filter is applied
                var selectedCriteriaIds = $selectedCriterias.map(function () { return this.id; }).get();
                var selectedCriterias = getSelectedCheckboxCriterias(filterData.Criterias, selectedCriteriaIds);
                excludedItemsMap[filterData.clientId] = _.difference(allItems, getCriteriasItems(selectedCriterias));
                appliedFilters[filterData.Name] = _.pluck(selectedCriterias, 'Name');
            } else {
                // Filter is not applied
                delete excludedItemsMap[filterData.clientId];
                delete appliedFilters[filterData.Name];
            }

            updateOtherFilters($filter);

            applyFilters();
        }

        function updateTotalProductCount() {
            const totalCount = _.difference(allItems, getAllExcludedItems()).length;
            const $productFilters = $('.' + classes.productFilters);

            $productFilters.find('.' + classes.totalCount).text(totalCount || "");

            if(totalCount == 0) {
                $productFilters.find('.' + classes.totalCountContainer).addClass('d-none');
            } else {
                $productFilters.find('.' + classes.totalCountContainer).removeClass('d-none');
            }
        }

        function notify(message, type) {
            var notificationChannel = typeof (type) === 'string' && type ? 'notification.' + type : 'notification';
            pubSub.publish(notificationChannel, message);
        }
        function blockUI() {
            if (typeof ($.blockUI) === 'function') {
                $mainPanel.block({ message: null });
            }
        }
        function unblockUI() {
            if (typeof ($.unblockUI) === 'function') {
                $mainPanel.unblock();
            }
        }
        //#endregion

        function runTemplateLocalScript(filters) {
            var templateName = $('.' + classes.template).val();

            var Template = templateName;
            var UC = 'uc' + controlId;
            var UCTemplated = UC + '-' + Template;

            var selectedCriteriaTemplate = '<button type="button" class="criteria js-' + UCTemplated + '-selected-criteria" data-criteria-id="<%- criteriaID %>"><span class="applied-name"><%- appliedFilter %></span><span class="applied-criteria"><%- appliedCriteria %></span><span class="icon"></span></button>';
            var precompiledSelectedCriteriaTemplate = _.template(selectedCriteriaTemplate);

            var sectionSelectedCriteriaTemplate = '<span class="criteria"><%- criteriaLabel %></span>';
            var sectionPrecompiledSelectedCriteriaTemplate = _.template(sectionSelectedCriteriaTemplate);

            // Specific template classes
            var templateClasses = {
                noAppliedFilters: 'no-applied-filters',
                hasAppliedFilters: 'has-applied-filters',
                openAfterFilterApplied: 'open-after-filter-applied',

                // Specific dropdown ctiterias
                sectionSelectedCriterias: 'js-' + UCTemplated + '-section-selected-criterias',
                sectionBtnBack: 'js-' + UCTemplated + '-section-back',

                sectionSelectedCriteriaCount: 'js-' + UCTemplated + '-selected-criteria-count',

                // All selected criterias from all dropdowns
                selectedCriterias: 'js-' + UCTemplated + '-selected-criterias',
                selectedCriteria: 'js-' + UCTemplated + '-selected-criteria',
                clearSelectedCriterias: 'js-' + UCTemplated + '-clear-selected-criterias',

                // Dropdown representing a filter
                dropdownItem: 'js-' + UCTemplated + '-dropdown-item',
                dropdownItemClosed: 'is-closed',
                dropdownItemOpened: 'is-opened',
                dropdownItemDisabled: 'is-disabled',
                dropdownBtn: 'js-' + UCTemplated + '-dropdown-btn',
                dropdownTitleBtn: 'js-' + UCTemplated + '-dropdown-title-btn',

                // Checkbox Filter
                checkboxFilter: 'js-' + UC + '-checkbox-filter',

                // Filter item - wrapper for criteria
                filterItem: 'js-' + UCTemplated + '-filter-item',
                filterItemDisabled: 'is-disabled',
                filterItemIsHidden: 'is-mobile-hidden',
                criteriaCheckbox: 'js-' + UCTemplated + '-filter-item-checkbox',
                criteriaLabel: 'js-' + UCTemplated + '-filter-item-label',

                // Close Button
                closeBtn: 'js-' + UC + '-close-btn',

                // Only in stock filter
                showOnlyInStock: 'js-' + UCTemplated + '-show-only-in-stock',

                // Sorting
                sortSelector: 'js-' + UCTemplated + '-sort-selector',
            };

            // UI Elements selected by template classes
            var $selectedCriterias = $('.' + templateClasses.selectedCriterias, $mainPanel);
            var $allSectionsSelectedCriterias = $('.' + templateClasses.sectionSelectedCriterias);
            var $clearSelectedCriterias = $('.' + templateClasses.clearSelectedCriterias, $mainPanel);
            var $dropdownItem = $('.' + templateClasses.dropdownItem, $mainPanel);
            var $dropdownBtn = $('.' + templateClasses.dropdownBtn, $mainPanel);
            var $dropdownTitleBtn = $('.' + templateClasses.dropdownTitleBtn, $mainPanel);
            var $filterItem = $('.' + templateClasses.filterItem, $mainPanel);
            var $criteriaLabel = $('.' + templateClasses.criteriaLabel, $mainPanel);
            var $sectionBtnBack = $('.' + templateClasses.sectionBtnBack, $mainPanel);
            var $cbxShowOnlyInStock = $('.' + templateClasses.showOnlyInStock, $mainPanel);
            var $sortSelector = $('.' + templateClasses.sortSelector, $mainPanel);
            var initialNumberOfSelectedCheckboxes = 0;
            //var $selectedCriteria = $('.' + templateClasses.selectedCriteria, $mainPanel);

            // 🤘 time
            $mainPanel.addClass(UCTemplated);

            if ($cbxShowOnlyInStock.length) {
                $cbxShowOnlyInStock.prop('checked', showOnlyInStock === true);
                $cbxShowOnlyInStock.change(onCbxShowOnlyInStockChange);
            }

            if ($sortSelector.length) {
                $sortSelector.val(initSortingOption);
                $sortSelector.change(onSortSelectorChange);
            }
            // Subscribe to popstate event
            $(w).on('popstate', onHistoryPopState);

            function onHistoryPopState(evt) {
                var state = evt.originalEvent.state;
                if (state && state.controlId === productListControlId) {
                    // Update filters states only, product list is already refreshed from state
                    if (typeof state.sort !== 'undefined' && $sortSelector.length) {
                        $sortSelector.val(state.sort);
                    }
                }
            }

            // Delegate clicks from specific theme buttons to the UC195 Control buttons placed ousite the theme markup
            $clearSelectedCriterias.click(function (evt) {
                $filterItem.removeClass(templateClasses.filterItemDisabled);
                $dropdownItem.removeClass(templateClasses.dropdownItemDisabled);
                $resetButton.trigger('click');

                $('.' + templateClasses.selectedCriteria, $mainPanel).remove();

                updateSelectedCriteriaBtn(templateClasses);
            });

            $sectionBtnBack.on('click', function () {
                $sectionBtnBack.closest('.' + templateClasses.dropdownItem).hasClass(templateClasses.dropdownItemOpened) ? $sectionBtnBack.closest('.' + templateClasses.dropdownItem).removeClass(templateClasses.dropdownItemOpened).addClass(templateClasses.dropdownItemClosed) : null;
            });

            // click on dropdown button (to expand filter criterias on mobile devices)
            $dropdownItem.click(function(e){
                var index = $(this).index();

                $(this).find('.' + templateClasses.filterItem + ':gt(2)').addClass(templateClasses.filterItemIsHidden);

                if ($(this).hasClass(templateClasses.dropdownItemOpened)) {
                    $(this).removeClass(templateClasses.dropdownItemOpened).addClass(templateClasses.dropdownItemClosed);
                } else {
                    $dropdownItem.removeClass(templateClasses.dropdownItemOpened).addClass(templateClasses.dropdownItemClosed).eq(index).removeClass(templateClasses.dropdownItemClosed).addClass(templateClasses.dropdownItemOpened);
                }

                e.stopPropagation();
            });

            $('.' + templateClasses.checkboxFilter).click(function(e){

                updateSelectedCriteriaBtn(templateClasses);

                e.stopPropagation();
            });

            $('.' + templateClasses.checkboxFilter + ' .' + templateClasses.closeBtn).on('click', function (e) {
                $('#collapsableProductFilters').collapse('toggle');
            });

            $(document).click(function(){
                $dropdownItem.removeClass(templateClasses.dropdownItemOpened).addClass(templateClasses.dropdownItemClosed);
            });

            // click on dropdown button (to expand filter criterias on mobile devices)
            $dropdownTitleBtn.on('click', function (e) {
                var currentNumberOfSelectedCheckboxes = _.size($('.' + templateClasses.criteriaCheckbox + ':checked'));

                $dropdownItem.find('.' + templateClasses.filterItem + ':gt(2)').addClass(templateClasses.filterItemIsHidden);

                if ($dropdownItem.hasClass(templateClasses.dropdownItemOpened)) {
                    $dropdownItem.removeClass(templateClasses.dropdownItemOpened).addClass(templateClasses.dropdownItemClosed);
                } else {
                    if (initialNumberOfSelectedCheckboxes === currentNumberOfSelectedCheckboxes) {
                        $dropdownItem.removeClass(templateClasses.dropdownItemClosed).addClass(templateClasses.dropdownItemOpened);
                    } else {
                        $dropdownItem.addClass(templateClasses.openAfterFilterApplied);
                    }
                }

                var $mainPanelTopBox = $('.TopBox', $mainPanel);

                $mainPanelTopBox.find('.' + templateClasses.selectedCriteria).remove();

                if(currentNumberOfSelectedCheckboxes>0){
                    $mainPanelTopBox.append('<span class="' + templateClasses.selectedCriteria + '">' + currentNumberOfSelectedCheckboxes + '</span>');
                }

                updateSelectedCriteriaBtn(templateClasses);

                e.stopPropagation();
            });

            // handle click on selected criteria
            $($selectedCriterias).on('click', '.' + templateClasses.selectedCriteria, function (evt) {
                var criteriaID = $(evt.currentTarget).data('criteria-id');
                var $criteriaCheckbox = $('.' + templateClasses.criteriaCheckbox).filter('[id=' + criteriaID + ']');
                var $filter = $criteriaCheckbox.closest('.' + classes.filter);

                $criteriaCheckbox.attr('checked', false);
                applySelectedCheckboxesFilter($filter);
                $(this).remove();

                updateSelectedCriteriaBtn(templateClasses);
            });

            // use pubSub.subscribe instead of change event
            // because this is dynamic filter and checking one criteria can cause changes for another criterias
            pubSub.subscribe(filtersChannelPrefix + '.apply', function (ignore, filterState) {
                // handle selected criterias
                $selectedCriterias.add($allSectionsSelectedCriterias).empty();
                $('.' + templateClasses.sectionSelectedCriterias).remove();

                var filter, criteria;

                $.each(filterState.appliedFilters, function (appliedFilter, appliedCriterias) {
                    filter = _.find(filters, function (filter) {
                        return filter.Name === appliedFilter;
                    });
                    // skip price filter and slideble filters
                    if (!filter || filter.slideble) {
                        return true; // continue .each loop
                    }
                    var $sectionCriteriasContainer = $('<div class="selected-criterias js-' + UCTemplated + '-section-selected-criterias"/>');
                    var $dropdown = $('#' + filter.clientId);
                    var $templateFilterItem = $dropdown.closest($('.' + templateClasses.dropdownItem));
                    var $dropdownBtn = $templateFilterItem.find($('.' + templateClasses.dropdownBtn));
                    var $embdedSectionCriteriasContainer = $templateFilterItem.find('.' + templateClasses.sectionSelectedCriterias);
                    $embdedSectionCriteriasContainer.empty();

                    $.each(appliedCriterias, function (index, appliedCriteria) {
                        criteria = _.find(filter.Criterias, function (criteria) {
                            return criteria.Name === appliedCriteria;
                        });
                        if (!criteria) {
                            return true; // continue .each loop
                        }

                        $sectionCriteriasContainer.append(sectionPrecompiledSelectedCriteriaTemplate({
                            criteriaLabel: appliedCriteria
                        }));

                        $selectedCriterias.append(precompiledSelectedCriteriaTemplate({
                            criteriaID: criteria.clientId,
                            appliedFilter: appliedFilter,
                            appliedCriteria: appliedCriteria
                        }));
                    });

                    if ($embdedSectionCriteriasContainer.length === 0) {
                        $dropdownBtn.append($sectionCriteriasContainer);
                    } else {
                        $embdedSectionCriteriasContainer.replaceWith($sectionCriteriasContainer);
                    }

                });

                if (_.size(filterState.appliedFilters)) {
                    $mainPanel.addClass(templateClasses.hasAppliedFilters).removeClass(templateClasses.noAppliedFilters);
                } else {
                    $mainPanel.removeClass(templateClasses.hasAppliedFilters).addClass(templateClasses.noAppliedFilters);
                }
            });

            // catch filter changes
            // but these changes not applied yet, .apply fires after Apply button click if enableImmediateFiltering is false
            pubSub.subscribe(filtersChannelPrefix + '.update', function (ignore) {
                // go through all checkboxes to mark disabled criterias
                $filters.each(function () {
                    var $filter = $(this);
                    var $filterItemTemp;
                    var $dropdownItem = $filter.closest('.' + templateClasses.dropdownItem);
                    //var $embdedSectionCriteriasContainer = $dropdownItem.find('.' + templateClasses.sectionSelectedCriterias);
                    if (!$filter.hasClass(classes.checkboxFilter)) {
                        return true; // continue .each loop
                    }
                    // checkboxes already has disabled/enabled states from previous step
                    // so just check this state and mark filter item if needed
                    $filter.find('.' + templateClasses.criteriaCheckbox).each(function () {
                        $filterItemTemp = $(this).closest('.' + templateClasses.filterItem);
                        if ($(this).is(':disabled')) {
                            $filterItemTemp.addClass(templateClasses.filterItemDisabled);
                        } else {
                            $filterItemTemp.removeClass(templateClasses.filterItemDisabled);
                        }
                    });
                    // if all criterias are disabled - mark dropdown item as disabled too
                    if ($filter.find('.' + templateClasses.filterItem).length === $filter.find('.' + templateClasses.filterItemDisabled).length) {
                        $dropdownItem.addClass(templateClasses.dropdownItemDisabled);
                    } else {
                        $dropdownItem.removeClass(templateClasses.dropdownItemDisabled);
                    }
                });
                if (_.size(appliedFilters)) {
                    $mainPanel.addClass(templateClasses.hasAppliedFilters).removeClass(templateClasses.noAppliedFilters);
                } else {
                    $mainPanel.removeClass(templateClasses.hasAppliedFilters).addClass(templateClasses.noAppliedFilters);
                }
            });

            pubSub.subscribe(filtersChannelPrefix + '.load', function (ignore, filters) {
                initialNumberOfSelectedCheckboxes = _.size($('.' + templateClasses.criteriaCheckbox + ':checked'))
                $dropdownItem.each(function () {
                    $(this).find('.' + templateClasses.filterItem + ':gt(2)').addClass(templateClasses.filterItemIsHidden);
                });

                if (_.size(appliedFilters)) {
                    $mainPanel.addClass(templateClasses.hasAppliedFilters).removeClass(templateClasses.noAppliedFilters);
                } else {
                    $mainPanel.removeClass(templateClasses.hasAppliedFilters).addClass(templateClasses.noAppliedFilters);
                }
            });
            pubSub.subscribe(filtersChannelPrefix + '.sortingchanged', function (topic, sortBy) { 
                $sortSelector.val(sortBy);
            });
        }

        function updateCounterSelectedCriteria() {
            const templateName = $('.js-uc' + controlId + '-template').val();
            const classRoot = 'uc' + controlId + '-' + templateName;

            // Specific template classes
            var templateClasses = {
                selectedCriteria: 'js-' + classRoot + '-selected-criteria',

                // Filter item - wrapper for criteria
                filterItem: 'js-' + classRoot + '-filter-item',
                filterItemIsHidden: 'is-mobile-hidden',
                criteriaCheckbox: 'js-' + classRoot + '-filter-item-checkbox',
                dropdownItem: 'js-' + classRoot + '-dropdown-item',
            };

            var currentNumberOfSelectedCheckboxes = _.size($('.' + templateClasses.criteriaCheckbox + ':checked'));

            var $mainPanelTopBox = $('.TopBox', $mainPanel);

            $mainPanelTopBox.find('.' + templateClasses.selectedCriteria).remove();
            $mainPanelTopBox.find('.' + templateClasses.selectedCriteria).removeClass('has-selected-criteria');

            if(currentNumberOfSelectedCheckboxes>0) {
                $mainPanelTopBox.find("button").append(' <span class="' + templateClasses.selectedCriteria + '">(' + currentNumberOfSelectedCheckboxes + ')</span>');
                $mainPanelTopBox.find('.' + templateClasses.selectedCriteria).addClass('has-selected-criteria-group');
            }

            updateSelectedCriteriaBtn(templateClasses);
        }

        function updateSelectedCriteriaBtn(templateClasses) {
            $.each($('.' + templateClasses.dropdownItem), function (index, item) {
                var $item = $(item);

                var currentNumberOfSelectedCheckboxesGroup = _.size($item.find('.' + templateClasses.criteriaCheckbox + ':checked'));

                if (currentNumberOfSelectedCheckboxesGroup > 0) {
                    $item.hasClass('has-selected-criteria-group') ? '' : $item.addClass('has-selected-criteria-group');
                } else {
                    $item.removeClass('has-selected-criteria-group');
                }
            });
        }

        loadFilters();

        function onCbxShowOnlyInStockChange() {
            var $this = $(this);
            showOnlyInStock = $this.prop('checked');

            loadFilters(function () {
                setAppliedFilters(appliedFilters);
                applyFilters();
            });
        }

        function onSortSelectorChange() {
            var sortBy = this.value;
            pubSub.publish(filtersChannelPrefix + '.sortingchanged', sortBy);
        }

        $(function () {
            domReady = true;
            $mainPanel = $('#' + ctx.mainPanelId);
            $filtersContainer = $('.' + classes.filtersContainer, $mainPanel);
            $buttonsContainer = $('.' + classes.buttonsContainer, $mainPanel);
            $resetButton = $('.' + classes.resetBtn, $buttonsContainer);
            $closeButton = $('.' + classes.closeBtn, $mainPanel);
            $cbxShowOnlyInStock = $('.' + classes.showOnlyInStock, $mainPanel);
            $sortSelector = $('.' + classes.sortSelector, $mainPanel);

            if (filtersData) {
                showFilters(filtersData);
            }

            $resetButton.on('click', function (e) {
                onResetButtonClick(e);
                updateCounterSelectedCriteria();
            });

            $closeButton.on('click', function (e) {
                updateCounterSelectedCriteria();
            });

            // Subscribe to popstate event
            $(w).on('popstate', onHistoryPopState);

            function onHistoryPopState(evt) {
                var state = evt.originalEvent.state;
                if (state && state.controlId === productListControlId) {
                    // Update filters states only, product list is already refreshed from state
                    if (typeof state.sort !== 'undefined' && $sortSelector.length) {
                        $sortSelector.val(state.sort);
                    }

                    if (typeof state.showOnlyInStock === 'boolean' && state.showOnlyInStock !== showOnlyInStock) {
                        if ($cbxShowOnlyInStock.length) {
                            $cbxShowOnlyInStock.prop('checked', state.showOnlyInStock === true);
                        }

                        showOnlyInStock = state.showOnlyInStock;

                        loadFilters(function () {
                            setAppliedFilters(typeof (state.appliedFilters) !== 'undefined' ? state.appliedFilters : {});
                            applyFilters(true, true);
                        });
                    } else {
                        setAppliedFilters(typeof (state.appliedFilters) !== 'undefined' ? state.appliedFilters : {});
                        applyFilters(true, true);
                    }
                }
            }

            if ($cbxShowOnlyInStock.length) {
                $cbxShowOnlyInStock.prop('checked', showOnlyInStock === true);
                $cbxShowOnlyInStock.change(onCbxShowOnlyInStockChange);
            }

            if ($sortSelector.length) {
                $sortSelector.change(onSortSelectorChange);
            }

            pubSub.subscribe(staticfilterChannelPrefix + '.apply', function (topic, itemsCount) {
                loadFilters();
            });

            pubSub.subscribe(staticfilterChannelPrefix + '.reset', function (topic) {
                w.removeFromLocalStorage(savedFiltersLocalStorageKey);

                setAppliedFilters();
                applyFilters();
            });

            pubSub.subscribe(listReadyChannelPrefix,
                function () {
                    if (preAppliedFilterState)
                        pubSub.publish(filtersChannelPrefix + '.apply', preAppliedFilterState);
            });

            pubSub.subscribe(filtersChannelPrefix + '.sortingchanged', function (topic, sortBy) { 
                $sortSelector.val(sortBy);
            });

            pubSub.subscribe(filtersChannelPrefix + '.apply', function (topic, itemsCount) {
                $cbxShowOnlyInStock.prop('checked', showOnlyInStock === true);
            });
        });
    }
})(window, jQuery, _);